import React, {useState, useEffect} from "react";
import { Box, Typography, TextField, Divider, Grid, FormControlLabel, Checkbox, MenuItem, Tabs, Tab, Button, IconButton,Table, TableHead, TableBody, TableRow, TableCell, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useOutletContext, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLogger } from "../../hooks/useLogger";
import { developerTollApi } from "../../services/developerTollApi";
import Loader from "../../components/Loader";
import UsersTable from "../../components/Users/usersTable";
import Cookies from "js-cookie";
import { companyDetail } from "../../store/reducers/companyDetails";

const Users = () => {
    const dispatch = useDispatch();
    const logEvent = useLogger();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { open } = useOutletContext();
    const [loader, setLoader] = useState(false);
    const [users, setUsers] = useState([]);
    const [openEditor, setOpenEditor] = useState(false);
    const [selecteduser, setSelecteduser] = useState(null);
    const [userEdit, setUserEdit] = useState(false);
    const token = Cookies.get("_d_token");
    
    const fetchUsers = async () => {
        setLoader(true);
        try {
            const response = await developerTollApi.getUsers();
            console.log(response)
            if(response?.status)
            {
                setUsers(response?.data);
                dispatch(companyDetail());
            }
        } catch (error) {
            console.error("Error fetching line chart data:", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if(token) fetchUsers();
    }, [token]);

    return (<>
        <Box sx={{ flexGrow: 1, p: 3, width: isMobile ? "100%" : open ? "calc(100% - 280px)" : "calc(100% - 100px)", marginLeft: isMobile ? "0" : open ? "280px" : "100px", transition: "margin 0.3s ease", height: "100vh", display: "flex", background: "#f9f9f9", }}>
            <Box mt={10} style={{ borderRadius: "12px", textAlign: "center", background: "#fff", width: "100%", height: "calc(100% - 76px)", marginLeft: open ? "" : "1em", }}>
                <Box sx={{ display: "flex", alignItems:'center', justifyContent: "space-between", padding: "20px 25px" }}>
                    <Typography noWrap component="p" sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>
                        Users
                    </Typography>
                    
                    <Button variant="contained" sx={{ width: '170px', height: 40, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"} }} onClick={() => {setOpenEditor(true); setSelecteduser(null); setUserEdit(false)}} >
                        + Add User
                    </Button>
                </Box>
                <Divider />
                <Box sx={{ overflow: "auto", height: "calc(100% - 90px)" }}>
                    {users && (<UsersTable users={users} setSelecteduser={setSelecteduser} selecteduser={selecteduser} setOpenEditor={setOpenEditor} openEditor={openEditor} setUserEdit={setUserEdit} userEdit={userEdit} fetchUsers={fetchUsers} />)}
                </Box>
            </Box>
        </Box>
        {loader && (<Loader />)}

    </>);
};

export default Users;
